import { cn } from '@/common/lib/cn/cn'
import { clampPercent, getPercentVariant, variantBarClass, type StatProgressBarProps } from './statProgressBarUtils'

export function StatProgressBar({ value, variant = 'auto', className, 'aria-label': ariaLabel }: StatProgressBarProps) {
    const percent = clampPercent(value)
    const resolvedVariant = variant === 'auto' ? getPercentVariant(percent) : variant

    return (
        <div
            className={cn('h-1 w-full overflow-hidden rounded-full bg-white/10', className)}
            role='progressbar'
            aria-valuenow={percent}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={ariaLabel}
        >
            <div
                className={cn('h-full rounded-full transition-all', variantBarClass[resolvedVariant])}
                style={{ width: `${percent}%` }}
            />
        </div>
    )
}
